@use '@lib/assets/styles/main.scss' as *;

.root {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  white-space: nowrap;
  width: 100%;
}
